import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_395xq4ekla: FaireBrandEntity = {
  token: "b_395xq4ekla",
  type: "brand",
  name: "By Together",
  avatarUrl:
    "https://cdn.faire.com/fastly/590cb4c04891cb079c8eece6cb632aca4c6df13b4388e7b2984c8ab3e80f316c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/38724cb31ceaedfb84d61c7481e156930abc5443ba2fa8621a3089078c576b6f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/590cb4c04891cb079c8eece6cb632aca4c6df13b4388e7b2984c8ab3e80f316c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/38724cb31ceaedfb84d61c7481e156930abc5443ba2fa8621a3089078c576b6f.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.8,
  reviewCount: 671,
  isInsider: true,
  description:
    "Founded in 2009,  By Together products consist of timeless yet trendy Boho Chic women’s apparel specifically tailored for women of everyday lifestyle. \n\nOur mission is to maximize our community’s success with greater quality goods & services. \n\nShop the brand today and experience the ultimate luxury of ready-to-wear fashion, now and forever, By Together.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:12.188Z",
    importedBy: "entity-db-cli",
  },
};
